import _ from 'underscore';
import { sleep } from '../utils';
import * as types from '../actions/actionTypes';
import store from '../store';
import { updateStatuses, imageStatuses, cloneStatuses, operationStatuses, licenceStatuses } from '../statuses';
import operationTypes from '../operationTypes';
import permissionLevel from '../permissionLevel';

function mockResponse(v, reponseStatus, paginated) {
    const headers = new Headers({
        'Content-Type': 'application/json',
        'X-Server-Version': '0.5.0.0'
    });

    const init = { status: reponseStatus, headers: headers };
    const json = JSON.stringify(paginated ? { items: v, skipped: 0, totalCount: 0 } : v);

    return new Response(json, init);
}

function randomString(typeDescription) {
    return typeDescription + '-' + randomStringOfLength(4);
}

function getTodayDate() {
    var today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}

function getSSCProdDate() {
    var date = getTodayDate();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 3, (Math.floor(Math.random()*59)))
}

function getSSCForumDate() {
    var date = getTodayDate();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 2, (Math.floor(Math.random()*59)))
}

function getSODate() {
    var date = getTodayDate();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, (Math.floor(Math.random()*59)))
}

function getCloneDate() {
    var date = getTodayDate();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 8, (Math.floor(Math.random()*59)))
}

function getCloneSize() {
    var size = Math.pow(2, 22) * (0.25 + Math.random());
    while (size < 40960000)
    {
        size = size * 2;
    }
    return size;
}

const randomStringOfLength = (length) => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for(let i=1; i <= length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
};

function promise(v = {}, reponseStatus = 200, paginated = false) {
    return sleep(300).then(() => Promise.resolve(mockResponse(v, reponseStatus, paginated)));
}

function fakeExternallyTriggeredAction(messageType, value, afterMs = 300) {
    sleep(afterMs).then(() => store.dispatch({
        type: messageType, updateStatus: updateStatuses.success, value: value
    }));
    return randomString('non-user-facing-operation');
}

function fakeDatabaseNames() {
    const number = Math.floor((Math.random() * 2) + 1);
    switch (number) {
        case 1:
            return fakeFetchInstanceDetails1;
        case 2:
            return fakeFetchInstanceDetails2;

        default:
            return fakeFetchInstanceDetails1;
    }
}

function fakeInstanceDetails(serverInstanceId) {
    return {
        instanceId: serverInstanceId,
        isSuccess: true,
        databases: fakeDatabaseNames(),
        errorMessage: null
    };
};

function randomOriginFromInstance(serverInstance) {
    return {
        serverName: serverInstance.server + '\\' + serverInstance.instance,
        databaseName: randomString('database')
     };
}

const fakeUserDetails = {
    id: '9541b556-5f90-42bf-87a0-be3d17d1f7e6-jordan-miller',
    name: 'SQL Clone User',
    email: null
};

const fakeImageStatus = () => ({ sizeInBytes: Math.pow(2, 36) * (0.25 + Math.random()), state: imageStatuses.created });
const fakeCloneStatus = () => ({ sizeInBytes: getCloneSize(), state: cloneStatuses.online });

const fakeStartImageOperationData = image => {

    const imageId = randomString('image');
    const operationId = randomString('createImageOperation');

    let percentage = 0;

    const intervalHandle = setInterval(() => {

        percentage++;

        fakeExternallyTriggeredAction(types.OPERATION_PROGRESS_UPDATED, { parentId: operationId, percentage: percentage }, 0);
    }, 100);

    fakeExternallyTriggeredAction(types.OPERATION_STATUS_UPDATED, 
        { id: operationId, status: { state: operationStatuses.started } }, 100);

    fakeExternallyTriggeredAction(types.IMAGE_STATUS_UPDATED, 
        { id: imageId, status: fakeImageStatus() }, 3900);

    setTimeout(() => {
        fakeExternallyTriggeredAction(types.OPERATION_STATUS_UPDATED, 
            { id: operationId, status: { state: operationStatuses.successful } }, 0);

        clearInterval(intervalHandle);
    }, 4000);

    // This needs to match up what comes out of "HTTP POST /api/images"
    return { 
        imageId: imageId, 
        image: { 
            ...image, 
            name: image.imageName, 
            createdBy: fakeUserDetails.name, 
            createdDate: new Date().toString(), 
            origin: randomOriginFromInstance({ server: 'unknownServer', instance: 'unknownInstance' }),
            status: { 
                state: imageStatuses.beingCreated, 
                sizeInBytes: 0 
            },
            latestOperation: { 
                id: operationId, 
                value: { 
                    type: operationTypes.createImage, 
                    startedByUser: fakeUserDetails.name,
                    timestamp: new Date().toISOString(),
                    status: { 
                        state: operationStatuses.userRequested 
                    } 
                } 
            } 
        }
    }; 
};

const fakeStartCloneOperationData = clone => {
    const cloneId = randomString('clone');
    const operationId = randomString('createCloneOperation');
    fakeExternallyTriggeredAction(types.OPERATION_STATUS_UPDATED, 
        { id: operationId, status: { state: operationStatuses.started } }, 100 );
    fakeExternallyTriggeredAction(types.CLONE_STATUS_UPDATED, 
        { id: cloneId, status: fakeCloneStatus() }, 1900 );
    fakeExternallyTriggeredAction(types.OPERATION_STATUS_UPDATED, 
        { id: operationId, status: { state: operationStatuses.successful } }, 2000 );

    return { cloneId: cloneId, clone: { ...clone, parentImageId: clone.imageId, status: { state: cloneStatuses.beingCreated, sizeInBytes: 0 }, createdBy: fakeUserDetails.name, 
                latestOperation: { id: operationId, value: { type: operationTypes.createClone, timestamp: new Date().toISOString(), status: { state: operationStatuses.userRequested } } } } };
};

const fakeFetchImageDestinationLocationsData =[
    { id: 'imageDestinationLocation0', value: { uncPath: '\\\\images' } },
    { id: 'imageDestinationLocation1', value: { uncPath: '\\\\share\\images' } },
];

const fakeAgentsData = [
    {
        id: randomString('agent'),
        value: {
            machineName: randomString('machineName'),
            thumbprint: '02355A0815E60CE04138AFC0206334EECD1EC8F7',
            status: {
                connected: 'connected',
                requiresUpgrade: false,
                windowsUsername: 'WIN-81FSQ9LHQCQ\\Administrator',
                version: {
                    major: 0,
                    minor: 5,
                    build: 0,
                    revision: 2480,
                    majorRevision: 0,
                    minorRevision: 2480
                },
                lastConnected: '2016-10-27T12:33:58.4647718Z'
            }
        }
    },
    {
        id: randomString('agent'),
        value: {
            machineName: randomString('machineName'),
            thumbprint: '02355A0815E60CE04138AFC0206334EECD1EC8F7',
            status: {
                connected: 'connected',
                requiresUpgrade: false,
                windowsUsername: 'WIN-81FSQ9LHQCQ\\Administrator',
                version: {
                    major: 0,
                    minor: 5,
                    build: 0,
                    revision: 2480,
                    majorRevision: 0,
                    minorRevision: 2480
                },
                lastConnected: '2016-10-27T12:33:58.4647718Z'
            }
        }
    }
];

const createFakeSqlServerInstance = (agentId) => {
    const id = randomString('sqlServerInstance');
    return { 
        id: id, 
        value: {
            id: id, 
            agentId: agentId,
            authType: 'agentWindows',
            server: randomString('server'), 
            instance: randomString('instance'),
            passwordId: null
        } 
    };
};

const fakeFetchServerInstancesData = [
    createFakeSqlServerInstance(fakeAgentsData[0].id),
    createFakeSqlServerInstance(fakeAgentsData[0].id),
    createFakeSqlServerInstance(fakeAgentsData[1].id),
    createFakeSqlServerInstance(fakeAgentsData[1].id),
    createFakeSqlServerInstance(fakeAgentsData[1].id)
];

const createFakeBackupLocation = (temporaryInstanceId) => {
    const id = randomString('backupLocation'); 
    return {
        id: id,
        value: {
            id: id,
            temporaryInstanceId: temporaryInstanceId,
            backupBasePath: `\\\\${randomString('share')}\\${randomString('backups')}`
        }
    };
};

const fakeFetchBackupLocationsData = [
    createFakeBackupLocation(fakeFetchServerInstancesData[0].id),
    createFakeBackupLocation(fakeFetchServerInstancesData[0].id),
    createFakeBackupLocation(fakeFetchServerInstancesData[2].id)
];

const createFakeAgentDetails = () => ({ 
    id: randomString('agent'), 
	value: {
		machineName: randomString('machineName'),
		thumbprint: '02355A0815E60CE04138AFC0206334EECD1EC8F7',
		status: {
			connected: 'connected',
			windowsUsername: 'WIN-81FSQ9LHQCQ\\Administrator',
			version: {
				major: 0,
				minor: 5,
				build: 0,
				revision: 2480,
				majorRevision: 0,
				minorRevision: 2480
			},
			lastConnected: '2016-10-27T12:33:58.4647718Z'
		}
	}
});

const createSqlServerInstanceValidationResponseDetails = () => ({
    id: randomString('operation'),
    value: {
        type: operationTypes.readOnly,
        timestamp: '2016-10-27T12:33:58.4647718Z',
        startedByUser: 'Steve Jones',
        status: {
            state: 'dispatchedToAgent'
        }
    }
});

const createBackupLocationValidationResponseDetails = () => ({
    id: randomString('operation'),
    value: {
        type: operationTypes.readOnly,
        timestamp: '2016-10-27T12:33:58.4647718Z',
        startedByUser: 'Steve Jones',
        status: {
            state: 'dispatchedToAgent'
        }
    }
});

const createValidateImageLocationResponseDetails = () => ({
    id: randomString('operation'),
    value: {
        type: operationTypes.readOnly,
        timestamp: '2016-10-27T12:33:58.4647718Z',
        startedByUser: 'Steve Jones',
        status: {
            state: 'dispatchedToAgent'
        }
    }
});

const fakeFetchInstanceDetails1 = ['SQLServerCentral', 'SQLServerCentral_Forums', 'Stackoverflow'];

const fakeFetchInstanceDetails2 = ['SQLServerCentral_Dev_Shared', 'SQLServerCentral_UAT', 'SQLServerCentral_Forums_UAT', 'SQLServerCentral_Forums_Dev_Shared'];

const fakeDeleteClone = cloneId => {
    const operationId = randomString('deleteCloneOperation');
    fakeExternallyTriggeredAction(types.OPERATION_STATUS_UPDATED, 
        { id: operationId, status: { state: operationStatuses.started } }, 100 );
    fakeExternallyTriggeredAction(types.CLONE_STATUS_UPDATED, 
        { id: cloneId, status: { state: cloneStatuses.deleted, sizeInBytes: 0 } }, 1900 );
    fakeExternallyTriggeredAction(types.OPERATION_STATUS_UPDATED, 
        { id: operationId, status: { state: operationStatuses.successful } }, 2000 );
    return { id: operationId, value: { type: operationTypes.dropClone, status: { state: operationStatuses.userRequested } } };
};

const fakeDeleteImage = imageId => {
    const operationId = randomString('deleteImageOperation');
    fakeExternallyTriggeredAction(types.OPERATION_STATUS_UPDATED, 
        { id: operationId, status: { state: operationStatuses.started } }, 100 );
    fakeExternallyTriggeredAction(types.IMAGE_STATUS_UPDATED, 
        { id: imageId, status: { state: imageStatuses.deleted, sizeInBytes: 0 } }, 900 );
    fakeExternallyTriggeredAction(types.OPERATION_STATUS_UPDATED, 
        { id: operationId, status: { state: operationStatuses.successful } }, 1000 );
    return { id: operationId, value: { type: operationTypes.dropImage, status: { state: operationStatuses.userRequested } } };
};
const fakeFetchImagesData = [
    { 
        id: '1', 
        value: { 
            name: 'SQLServerCentral_Prod',
            sourceLocationId: fakeFetchServerInstancesData[0].id,
            sourceLocationResourceNames: ['SQLServerCentral'],
            imageLocationId: 'imageDestinationLocation0',
            imageLocationResourceName: randomString('imageFile'),
            createdBy: 'REDGATE\\CloneAutomationUser',
            createdDate: getSSCProdDate(),
            origin: { serverName: fakeFetchServerInstancesData[0].server + '\\' + fakeFetchServerInstancesData[0].instance, databaseName: randomString('database') },
            status: { sizeInBytes: 41943040000, state: imageStatuses.created },
            latestOperation: {
                id: randomString('operation'),
                value: {
                    type: operationTypes.createImage,
                    status: {
                        state: operationStatuses.successful
                    }
                }
            }       
        },        
    },
    { 
        id: '2', 
        value: { 
            name: 'SQLServerCentral_Forums_Prod',
            sourceLocationId: fakeFetchServerInstancesData[1].id,
            sourceLocationResourceNames: ['SQLServerCentral_Forums'],
            imageLocationId: 'imageDestinationLocation0',
            imageLocationResourceName: randomString('imageFile'),
            createdBy: 'REDGATE\\CloneAutomationUser',
            createdDate: getSSCForumDate(),
            origin: randomOriginFromInstance(fakeFetchServerInstancesData[1]),
            status: { sizeInBytes: 35642040000, state: imageStatuses.created },
            latestOperation: {
                id: randomString('operation'),
                value: {
                    type: operationTypes.createImage,
                    status: {
                        state: operationStatuses.successful
                    }
                }
            }               
        }
    },
    { 
        id: '3', 
        value: { 
            name: 'Stackoverflow_Testing',
            sourceLocationId: fakeFetchServerInstancesData[1].id,
            sourceLocationResourceNames: ['Stackoverflow'],
            imageLocationId: 'imageDestinationLocation1',
            imageLocationResourceName: randomString('imageFile'),
            createdBy: 'REDGATE\\Steve.Jones',
            createdDate: getSODate(),
            origin: randomOriginFromInstance(fakeFetchServerInstancesData[1]),
            status: { sizeInBytes: 98564040000, state: imageStatuses.created },
            latestOperation: {
                id: randomString('operation'),
                value: {
                    type: operationTypes.createImage,
                    status: {
                        state: operationStatuses.successful
                    }
                }
            }               
        }
    },
];

const fakeFetchClonesData = [
    {
        id: randomString('clone'),
        value: {
            locationId: fakeFetchServerInstancesData[0].id,
            name: 'SQLServerCentral_UAT',
            parentImageId: '1',
            status: fakeCloneStatus(),
            createdBy: 'REDGATE\\CloneAutomationUser',
            createdOnUtc: getCloneDate(),
            latestOperation: {
                id: randomString('operation'),
                value: {
                    type: operationTypes.createClone,
                    status: {
                        state: operationStatuses.successful
                    }
                }
            }
        }
    },
    {
        id: randomString('clone'),
        value: {
            locationId: fakeFetchServerInstancesData[1].id,
            name: 'SQLServerCentral_Dev_Shared',
            parentImageId: '1',
            status: fakeCloneStatus(),
            createdBy: 'REDGATE\\CloneAutomationUser',
            createdOnUtc: getCloneDate(),
            latestOperation: {
                id: randomString('operation'),
                value: {
                    type: operationTypes.createClone,
                    status: {
                        state: operationStatuses.successful
                    }
                }
            }

        }
    },
    {
        id: randomString('clone'),
        value: {
            locationId: fakeFetchServerInstancesData[3].id,
            name: 'SQLServerCentral_Dev_Steve',
            parentImageId: '1',
            status: fakeCloneStatus(),
            createdBy: 'REDGATE\\Steve.Jones',
            createdOnUtc: getCloneDate(),
        }
    },
    {
        id: randomString('clone'),
        value: {
            locationId: fakeFetchServerInstancesData[0].id,
            name: 'SQLServerCentral_Forums_UAT',
            parentImageId: '2',
            status: fakeCloneStatus(),
            createdBy: 'REDGATE\\CloneAutomationUser',
            createdOnUtc: getCloneDate(),
        }
    },
    {
        id: randomString('clone'),
        value: {
            locationId: fakeFetchServerInstancesData[1].id,
            name: 'SQLServerCentral_Forums_Dev_Shared',
            parentImageId: '2',
            status: fakeCloneStatus(),
            createdBy: 'REDGATE\\CloneAutomationUser',
            createdOnUtc: getCloneDate(),

        }
    },
];

let fakeAppliedPermissions = [];

const FakeApi = {
    getMe: () => promise(fakeUserDetails),
    startCreateImageOperation: details => promise(fakeStartImageOperationData(details), 202),
    fetchSqlServerInstances: () => promise(fakeFetchServerInstancesData, 200, true),
    requestSqlServerInstanceValidation: sqlServerInstance => {
        const responseDetails = createSqlServerInstanceValidationResponseDetails();
        window.setTimeout(() => {
            store.dispatch({
                type: types.SQL_SERVER_INSTANCE_STATUS_COMPLETED,
                updateStatus: updateStatuses.success,
                value: {
                    operationId: responseDetails.id,
                    isSuccess: true,
                    errorMessage: null
                }
            });
        }, 3000);

        return promise(responseDetails);
    },
    addSqlServerInstance: sqlServerInstance => promise(randomString('sqlServerInstance')),
    fetchInstanceDetails: (serverInstanceId) => 
        promise(fakeExternallyTriggeredAction(types.INSTANCE_DETAILS_UPDATED, fakeInstanceDetails(serverInstanceId)), 200, true),
    fetchBackupLocations: () => promise(fakeFetchBackupLocationsData, 200, true),
    fetchImageDestinationLocations: () => promise(fakeFetchImageDestinationLocationsData, 200, true),
    requestImageDestinationLocationValidation: validationRequest => {
        const responseDetails = createValidateImageLocationResponseDetails();
        window.setTimeout(() => {
            store.dispatch({
                type: types.IMAGE_LOCATION_VALIDATION_COMPLETED,
                updateStatus: updateStatuses.success,
                value: {
                    operationId: responseDetails.id,
                    isSuccess: true,
                    errorMessage: null
                }
            });
        }, 3000);

        return promise(responseDetails);
    },
    addImageDestinationLocation: imageDestinationLocation => promise(randomString('imageDestination')),
    requestBackupLocationValidation: backupLocation => {
        const responseDetails = createBackupLocationValidationResponseDetails();
        window.setTimeout(() => {
            store.dispatch({
                type: types.BACKUP_LOCATION_VALIDATION_COMPLETED,
                updateStatus: updateStatuses.success,
                value: {
                    operationId: responseDetails.id,
                    isSuccess: true,
                    errorMessage: null
                }
            });
        }, 3000);

        return promise(responseDetails);
    },
    addBackupLocation: backupLocation => promise(randomString('backupLocation')),
    updateBackupLocation: backupLocation => promise(),
    fetchImages: () => promise(fakeFetchImagesData, 200, true),
    fetchClones: () => promise(fakeFetchClonesData, 200, true),
    fetchAgents: () => promise(fakeAgentsData, 200, true),
    startCreateCloneOperation: (cloneDetails) => promise(fakeStartCloneOperationData(cloneDetails), 202),
    downloadInstaller: () => {
        fakeExternallyTriggeredAction(types.AGENT_STATUS_CHANGED, createFakeAgentDetails(), 4000);
    },
    deleteClone: id => promise(fakeDeleteClone(id), 202),
    deleteImage: id => promise(fakeDeleteImage(id), 202),
    fetchPermissions: () => promise(fakeAppliedPermissions),
    updatePermissions: (permissionDetails) => {
        fakeAppliedPermissions = [];

        if(permissionDetails.level === permissionLevel.groupBased) {
            const validScopeNames = _(validScopes).values();
            fakeAppliedPermissions.push({
                groupName: permissionDetails.groupName,
                allowedScopes: validScopeNames
            });
        }

        return promise({}, 204);
    },
    fetchLicence: () => promise({ 
        state: licenceStatuses.licensed, 
        description: 'In trial, 12 days remaining', 
        timestamp: new Date().toString() }, 200)
};

export default FakeApi;



// WEBPACK FOOTER //
// ./src/js/serverApi/fakeApi.js